<template>
	<div id="index" ref="appRef">
		<div class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body" id="pushbtnbox">
				<Header @getTime="getTime"/>
				<div class="pushbtn" style=" position: absolute;top:0.84rem;left:57%">
					<el-button type="primary" v-if="!inpause" @click="pocBtn">暂停</el-button>
					<el-button type="primary" v-if="inpause" @click="pocBtn">继续</el-button>
				</div>
				<div class="company_content">
					<div class="enterprise_left">
						<left-top ref="leftTop"/>
						<companyPatent ref="patentCompany"/>
					</div>
					<div class="enterprise_center">
						<map-center ref="map"/>
					</div>
					<div class="enterprise_right">
						<right-top ref="rightTop"/>
						<companyBrand ref="brandCompany"/>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import "@/assets/scss/company.scss";
	import drawMixin from "../utils/drawMixin";
	import Header from './header'
	import leftTop from './company/left-top.vue';
	import rightTop from './company/right-top.vue';
	import companyPatent from './company/company-patent.vue';
	import companyBrand from './company/company-brand.vue';
	import mapCenter from './company/map_center.vue';
	import {getPageFourData} from '@/utils/api.js'
	export default {
		mixins: [drawMixin],
		data() {
			return {
				loading: true, //加载状态
				timer:'', //定时器
				inpause:false, // 是否继续
			};
		},
		components: {
			Header,
			leftTop,
			rightTop,
			companyPatent,
			mapCenter,
			companyBrand
		},
		mounted() {
			this.timer = setTimeout(() =>{
				if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
					this.$router.push('/five');
				}else{
					console.log(4,'已销毁')
				}
			},30000)
			this.cancelLoading();
			document.querySelector('body').setAttribute('style', 'background-color:#020308;')
		},
		beforeDestroy() {
			document.querySelector('body').setAttribute('style', 'background-color:#020308;')
		},
		methods: {
			// 获取年月
			getTime(val){
				var params = {
					year:val.year,
					month:val.mon,
				}
				getPageFourData(params).then(res=>{
					if(res.status == 200){
						this.$refs.leftTop.getData(res.data.zl);
						this.$refs.rightTop.getData(res.data.tm);
						this.$refs.patentCompany.getData(res.data.zl_list_top50);
						this.$refs.brandCompany.getData(res.data.tm_list_top50);
						this.$refs.map.getData(res.data.map,res.data.map_list);
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			},			
			pocBtn(){
				this.inpause = !this.inpause;
				console.log(this.inpause)
				if(this.inpause){
					console.log("cleartimeout")
					clearTimeout(this.timer);
				}else{
					this.timer = setTimeout(() =>{
						if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
							this.$router.push('/five');
						}else{
							console.log(2,'已销毁')
						}
					},30000)
				}
			}
		},
	};
</script>
<style>
.el-progress-bar__outer {
	background-color: rgba(255, 255, 255, 0.4);
}
</style>
<style lang="scss" scoped>
	.bg {
		background-image: url("../assets/two.png");
	}
</style>

